<template>
  <div>
    <slotModal
      :id-modal="'sandiUser'"
      :modal-title="'Ubah Kata Sandi'"
      v-model="dialog"
      @close="close"
    >
      <template v-slot:modal-content>
        <div class="p-x-20">
          <p class="f-Overpass f-14 f-w-400 m-0 p-t-10">
            Ubah kata sandi akun anda. Kata sandi harus terdiri dari minimal 8
            karakter, berisi kombinasi huruf besar, huruf kecil, dan angka.
          </p>
          <p class="f-Overpass f-12 f-w-400 m-0 f-c-grey padding-4">
            Terakhir diubah pada
            {{ $moment(dataAkun.updated_at).format("DD/MM/YYYY HH:mm") }}
          </p>

          <div class="p-b-16">
            <div class="p-t-20">
              <p class="f-Overpass f-14 f-c-grey m-0">
                Kata Sandi Lama <span class="required">*</span>
              </p>
              <input
                :type="!btnEye1 ? 'password' : 'text'"
                class="input-form-password p-t-12 p-b-12 f-16 f-Overpass f-w-400"
                id="oldPassword"
                v-model="oldSandi"
              />
              <span
                toggle="#oldPassword"
                class="button-eye"
                @click="btnEye1Event"
                ><font-awesome-icon
                  :icon="
                    !btnEye1 ? 'fa-regular fa-eye' : 'fa-regular fa-eye-slash'
                  "
                  rotation="180"
                  style="color: #6f7287"
                />
              </span>
            </div>
            <div class="p-t-20">
              <p class="f-Overpass f-14 f-c-grey m-0">
                Kata Sandi Baru <span class="required">*</span>
              </p>
              <input
                :type="!btnEye2 ? 'password' : 'text'"
                class="input-form-password p-t-12 p-b-12 f-16 f-Overpass f-w-400"
                id="newPassword"
                v-model="newsandi1"
              />
              <span
                toggle="#newPassword"
                class="button-eye"
                @click="btnEye2Event"
                ><font-awesome-icon
                  :icon="
                    !btnEye2 ? 'fa-regular fa-eye' : 'fa-regular fa-eye-slash'
                  "
                  rotation="180"
                  style="color: #6f7287"
                />
              </span>
            </div>
            <div class="p-t-20">
              <p class="f-Overpass f-14 f-c-grey m-0">
                Ulangi Kata Sandi Baru <span class="required">*</span>
              </p>
              <input
                :type="!btnEye3 ? 'password' : 'text'"
                class="input-form-password p-t-12 p-b-12 f-16 f-Overpass f-w-400"
                id="newPasswordConfirm"
                v-model="newSandi2"
              />
              <span
                toggle="#newPasswordConfirm"
                class="button-eye"
                @click="btnEye3Event"
                ><font-awesome-icon
                  :icon="
                    !btnEye3 ? 'fa-regular fa-eye' : 'fa-regular fa-eye-slash'
                  "
                  rotation="180"
                  style="color: #6f7287"
                />
              </span>
            </div>
          </div>
          <div class="p-t-20 p-b-20">
            <button
              class="btn btn-primary f-Overpass w-100"
              @click="handleButtonClick"
              :disabled="btnSimpan ? true : false"
            >
              <span
                class="spinner-border text-light f-16 spiner-border-sm"
                v-if="btnSimpan"
              ></span>
              <span v-if="!btnSimpan">Simpan</span>
            </button>
          </div>
        </div>
      </template>
    </slotModal>
    <changesVerification ref="changesVerif" />
  </div>
</template>

<script>
import slotModal from "@/components/slots/slotModal.vue";
import changesVerification from "./changesverification.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "sandiUser",
  components: {
    slotModal,
    changesVerification,
  },

  data() {
    return {
      dialog: false,
      btnEye1: false,
      btnEye2: false,
      btnEye3: false,
      oldSandi: "",
      newsandi1: "",
      newSandi2: "",
      btnSimpan: false,
    };
  },

  computed: {
    ...mapState("akun", {
      dataAkun: "dataAkun",
    }),
  },

  methods: {
    ...mapActions({
      postOtp: "akun/postOtp",
    }),
    open() {
      this.dialog = true;
    },

    close() {
      this.btnSimpan = false;
      this.dialog = false;
    },
    btnEye1Event() {
      if (this.btnEye1) {
        return (this.btnEye1 = false);
      }
      if (!this.btnEye1) {
        return (this.btnEye1 = true);
      }
    },
    btnEye2Event() {
      if (this.btnEye2) {
        return (this.btnEye2 = false);
      }
      if (!this.btnEye2) {
        return (this.btnEye2 = true);
      }
    },
    btnEye3Event() {
      if (this.btnEye3) {
        return (this.btnEye3 = false);
      }
      if (!this.btnEye3) {
        return (this.btnEye3 = true);
      }
    },
    async handleButtonClick() {
      this.btnSimpan = true;
      if (this.oldSandi && this.newsandi1 && this.newSandi2) {
        if (this.newsandi1 === this.newSandi2) {
          let dataPassword = {
            oldPassword: this.oldSandi,
            newPassword: this.newSandi2,
          };

          this.$store.commit("akun/setDataPassword", dataPassword);
          await this.postOtp().then((res) => {
            // console.log(res);
            if (res.status === 200) {
              this.$toast.success(res.message, { position: "top" });
              this.close();
              this.$refs.changesVerif.open();
            } else {
              this.$toast.error("Sistem Sedang Sibuk, Coba Lagi!", {
                position: "top",
              });
              this.btnSimpan = false;
            }
          });
          //
        } else {
          this.$toast.error("Kata sandi tidak sama", {
            position: "top",
          });
          this.btnSimpan = false;
        }
      } else {
        this.$toast.error("Data ada yang kosong", { position: "top" });
        this.btnSimpan = false;
      }
    },
  },
};
</script>

<style scoped>
.padding-4 {
  padding-top: 4px;
}
.button-eye {
  transform: translateY(30%);
  position: absolute;
  right: 0;
  padding-right: 30px;
}
</style>
